<template lang="html">
  <div class="team">
    <h2 class="no-margin mb-10">{{ $t('team_info') }}</h2>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">{{ $t('dashboard') }}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/trace_tokens' }">{{ $t('trace_tokens') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.query.name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="line"></div>
    <Members/>
  </div>
</template>

<script>
import Members from '@/components/traceToken/Members'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'self'
    ])
  },
  components: {
    Members
  }
}
</script>

<style lang="css">
</style>
